/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Custom_Desc6Inputs */

const en_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When Zapier/n8n hit their ceiling, custom automation steps close the gap without switching platforms.`)
};

const ar_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حين يصطدم Zapier أو n8n بسقفه، تسد خطوات أتمتة مخصصة الفجوة دون تبديل منصات.`)
};

const bn_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapier/n8n-এর সীমায় পৌঁছালে, কাস্টম অটোমেশন স্টেপ প্ল্যাটফর্ম বদল না করেই ফাঁকটি পূরণ করে।`)
};

const de_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn Zapier/n8n an ihre Grenzen stoßen, schließen Custom-Automatisierungsschritte die Lücke, ohne die Plattform zu wechseln.`)
};

const es_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando Zapier/n8n tocan su techo, los pasos de automatización a medida cierran la brecha sin cambiar de plataforma.`)
};

const fr_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsque Zapier/n8n atteint son plafond, des étapes d'automatisation sur mesure comblent l'écart sans changer de plateforme.`)
};

const pt_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quando Zapier/n8n atinge seu teto, as etapas de automação sob medida preenchem a lacuna sem trocar de plataforma.`)
};

const zh_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当 Zapier/n8n 达到上限时，自定义自动化步骤可以缩小差距，而无需切换平台。`)
};

const tr_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapier/n8n tavana ulaştığında, özel otomasyon adımları platform değiştirmeden boşluğu kapatır.`)
};

const ru_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Когда Zapier/n8n упёрлись в потолок, кастомные шаги автоматизации закрывают разрыв без смены платформы.`)
};

const pl_svc_automation_custom_desc6 = /** @type {(inputs: Svc_Automation_Custom_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiedy Zapier/n8n dobije do sufitu, customowe kroki automatyzacji zasypują lukę bez zmiany platformy.`)
};

/**
* | output |
* | --- |
* | "When Zapier/n8n hit their ceiling, custom automation steps close the gap without switching platforms." |
*
* @param {Svc_Automation_Custom_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_custom_desc6 = /** @type {((inputs?: Svc_Automation_Custom_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Custom_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_custom_desc6(inputs)
	if (locale === "bn") return bn_svc_automation_custom_desc6(inputs)
	if (locale === "de") return de_svc_automation_custom_desc6(inputs)
	if (locale === "es") return es_svc_automation_custom_desc6(inputs)
	if (locale === "fr") return fr_svc_automation_custom_desc6(inputs)
	if (locale === "pt") return pt_svc_automation_custom_desc6(inputs)
	if (locale === "zh") return zh_svc_automation_custom_desc6(inputs)
	if (locale === "tr") return tr_svc_automation_custom_desc6(inputs)
	if (locale === "ru") return ru_svc_automation_custom_desc6(inputs)
	if (locale === "pl") return pl_svc_automation_custom_desc6(inputs)
	return en_svc_automation_custom_desc6(inputs)
});
export { svc_automation_custom_desc6 as "svc_automation_CUSTOM_desc" }